module.exports = "https://static.wanderu.com/ui-react/_next/static/media/mx.fc15d31a.svg";